<span [class]="'d-flex ' + flexDirection" style="min-width: 0">
  <div class="d-flex">
    <mat-label [class]="classLabel" [style]="labelStyle">{{ label }}</mat-label>
    <mat-icon *ngIf="tooltip" class="icon-tooltip pt-n1" [matTooltip]="tooltip">info</mat-icon>
  </div>
  <mat-label [class]="classContent" [class.text-truncate]="truncate" (mouseenter)="onMouseEnter($event.target)">
    <span [matTooltip]="hint" #ref><ng-content></ng-content></span>
    <span *ngIf="!ref.innerHTML.trim()">{{ placeholder }}</span>
  </mat-label>
</span>
